(function () {
  'use strict'

  const MODULE_NAME = 'thismoment.analytics.core'
  const COOKIE_NAME = 'tm_analytics'
  const CONSENT_COOKIE_NAME = 'tm_cookie_consent'
  const VISITOR_COOKIE_NAME = 'tm_visitor_id'

  require('angular-uuid4')
  require('angular-base64')

  require('angular')
    .module(MODULE_NAME, [
      'base64',
      'uuid4',
      require('angular-cookies'),
      require('angular-segment-analytics'),
      require('./factory/analytics-api'),
      require('./component/consent-modal')
    ])
  // TODO: Mass rename analyticsSDK when done.
  // .provider('Analytics', analyticsProvider)
    .provider('analyticsSDK', analyticsProvider)
    .config(analyticsConfig)

  function analyticsProvider () {
    return {
      $get: analyticsService
    }
  }

  analyticsConfig.$inject = ['segmentProvider']
  function analyticsConfig (segmentProvider) {
    segmentProvider
      .setAutoload(false)
      .setCondition(segmentEnabled)

    segmentEnabled.$inject = ['SdkConfig']
    function segmentEnabled (SdkConfig) {
      return SdkConfig.get('tracking')
    }
  }

  analyticsService.$inject = [
    '$cookies',
    '$q',
    '$window',
    'segment',
    'segmentLoader',
    'uuid4',
    'AnalyticsAccountApi',
    'SdkConfig',
    'Modal'
  ]
  function analyticsService (
    $cookies,
    $q,
    $window,
    segment,
    segmentLoader,
    uuid4,
    AnalyticsAccountApi,
    SdkConfig,
    Modal
  ) {
    let sessionStartTime = null
    let hasTrackedExit = false
    const VISITOR_ID = getVisitorId()

    var consent = {
      status: 0,
      promise: null
    }
    var analyticsConsent = (function () {
      var defer = $q.defer()
      consent.promise = defer
      return defer.promise
    }())

    if (SdkConfig.get('cookie_consent_enabled')) {
      var consentCookie = $cookies.getObject(CONSENT_COOKIE_NAME)
      if (!consentCookie) {
        var consentModal = Modal()
        consentModal.open(
          {
            animation: false,
            component: 'thismomentAnalyticsConsentModal',
            windowClass: 'window-consent-modal',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              options: {
                size: 'lg',
                description: SdkConfig.get('cookie_consent_description'),
                title: SdkConfig.get('cookie_consent_title'),
                resolvePromise: () => {
                  setConsentCookie(true)
                  consent.promise.resolve()
                },
                rejectPromise: () => {
                  SdkConfig.set('tracking', false)
                  setConsentCookie(false)
                  consent.promise.reject('no tracking')
                }
              }
            }
          }
        )()
      } else {
        SdkConfig.set('tracking', consentCookie.consentGranted)
        if (consentCookie.consentGranted) {
          consent.promise.resolve()
        } else {
          clearSegmentCookies()
          consent.promise.reject('no tracking')
        }
      }
    } else {
      // no consent required so resolve the check
      consent.promise.resolve()
    }

    var analyticsConfig = (SdkConfig.get('tracking')) ? AnalyticsAccountApi.getConfig(analyticsConfigWin, analyticsConfigFail) : null

    return {
      mapContentProps: mapContentProps,
      setupEventTracking: setupEventTracking,
      setupPageTracking: setupPageTracking,
      setupExitTracking: setupExitTracking
    }

    function analyticsConfigWin (response) {
      var config = angular.merge(response.data, {
        'display URL': $window.location.href,
        'tm version': SdkConfig.get('version') || 1,
        'tm host': SdkConfig.get('env_host'),
        'tm environment': SdkConfig.get('env_name'),
        'tm URL': SdkConfig.get('content_cloud_url')
      })
      var cookie = $cookies.getObject(COOKIE_NAME)
      var identity = config['identity'] || {}

      // NOTE: SNIPPET_VERSION is used internally by analytics.js to
      // disable an analytics.page() call on initial page loading. Removal
      // will cause segment to make duplicate page calls and you to be
      // frustrated.
      $window.analytics.SNIPPET_VERSION = config['tm version']
      segmentLoader.load(SdkConfig.get('segment_api_key'))

      delete config.identity
      config['session trigger'] = config['session trigger'] || 'direct'
      config['session trigger detail'] = config['session trigger detail'] || $window.document.referrer

      if (SdkConfig.get('track_users')) {
        if (!angular.isUndefined(identity.id)) {
          // Identity comes from server response
          identity['tm anon id'] = identity.id
          delete identity.id
        } else if (angular.isObject(cookie)) {
          // Identity comes from cookie (returning user).
          // Reset cookie if id invalid.
          identity['tm anon id'] = uuid4.validate(cookie.userId) ? cookie.userId : setNewUser()
        } else {
          // Identity not available (new user)
          identity['tm anon id'] = setNewUser()
        }
      } else {
        identity = {}
        identity['tm anon id'] = '99999999-9999-9999-9999-999999999999'
      }

      $q.when(analyticsConsent).then(function () {
        segment.identify(identity['tm anon id'], identity)
        segment.group(SdkConfig.get('account_id'), config)
      }).catch(function () {
        // no tracking
      })

      return config

      function setNewUser () {
        var id = uuid4.generate()

        // TODO: Get correct SDK version from somewhere, omit otherwise.
        $cookies.putObject(COOKIE_NAME,
          { userId: id },
          { expires: (new Date(Math.pow(2, 32) * 1000)).toUTCString() }
        )

        return id
      }
    }

    function analyticsConfigFail (error) {
      console.log('ERROR: Analytics not enabled')
      console.log(error)

      SdkConfig.set('tracking', false)

      return null
    }

    function mapContentProps (item) {
      var contentDate = new Date(item.added_timestamp * 1000)

      return {
        'content id': parseInt(item.id, 10),
        'content class': item.class_name,
        'content type': item.type_name,
        'content source': item.source.source_name,
        'content creator': (angular.isString(item.source.author) && item.source.author.length) ? item.source.author : (angular.isString(item.source.username) && item.source.username.length) ? item.source.username : (item.user_name.length) ? item.user_name : 'UGC Submission',
        'content creation date': isNaN(contentDate.getDate()) ? '' : contentDate.toISOString(),
        'content title': item.title,
        'content description': item.description_ptf,
        'content tags': item.tags,
        'content extended data': item.extended,
        'content URL': item.source.post_url,
        'content metadata': item.metadata,
        'display position': parseInt(item.playlist_order, 10)
      }
    }

    function setupPageTracking (pageProperties) {
      return function trackPage (name) {
        $q.all([analyticsConsent, analyticsConfig]).then(function (serviceProperties) {
          segment.page(name,
            angular.merge(
              {},
              serviceProperties,
              pageProperties,
              getDuration(),
              {
                'tm visitor id': VISITOR_ID
              }
            )
          )
        }).catch(function () {
          // no tracking
        })
      }
    }

    function setupEventTracking (controllerProperties) {
      return function trackEvent (action, eventProperties, callback) {
        $q.all([analyticsConsent, analyticsConfig]).then(function (serviceProperties) {
          var properties = angular.merge(
            {},
            serviceProperties,
            controllerProperties,
            eventProperties,
            getDuration(),
            {
              'tm visitor id': VISITOR_ID
            }
          )
          properties['event trigger'] = properties['event trigger'] || 'unspecified'
          segment.track(action, properties, {}, callback)
        }).catch(function () {
          // no tracking
        })
      }
    }

    function setConsentCookie (consentGranted) {
      if (!consentGranted) {
        clearSegmentCookies()
      }
      $cookies.putObject(CONSENT_COOKIE_NAME,
        { consentGranted: consentGranted },
        { expires: (new Date(Math.pow(2, 32) * 1000)).toUTCString() }
      )
    }

    // THIS IS NOT PERSISTING!!!!
    function getVisitorId () {
      let visitorCookie = $cookies.getObject(VISITOR_COOKIE_NAME)
      if (!visitorCookie || !visitorCookie.visitorId) {
        visitorCookie = { visitorId: uuid4.generate() }
        $cookies.putObject(VISITOR_COOKIE_NAME,
          visitorCookie,
          { expires: (new Date(Math.pow(2, 32) * 1000)).toUTCString() }
        )
      }
      return visitorCookie.visitorId
    }

    function getDuration () {
      if (!sessionStartTime) {
        sessionStartTime = Date.now()
      }
      const duration = Math.floor((Date.now() - sessionStartTime) / 1000)
      return {
        duration_seconds: duration,
        duration_minutes: Math.floor(duration / 60)
      }
    }

    function trackTimeOnSite () {
      if (!hasTrackedExit && SdkConfig.get('tracking')) {
        hasTrackedExit = true

        $q.all([analyticsConsent, analyticsConfig]).then(function (serviceProperties) {
          const properties = angular.merge(
            {},
            serviceProperties,
            getDuration(),
            {
              'event trigger': 'page exit',
              'tm visitor id': VISITOR_ID
            }
          )
          segment.track('Time On Site', properties)
        }).catch(function () {
          // no tracking
        })
      }
    }

    function setupExitTracking () {
      $window.addEventListener('beforeunload', trackTimeOnSite)
      $window.addEventListener('pagehide', trackTimeOnSite)
    }

    function clearSegmentCookies () {
      $cookies.remove('ajs_anonymous_id')
      $cookies.remove('ajs_group_id')
      $cookies.remove('ajs_user_id')
    }
  };

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/analytics/analytics.js